import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Zink: hulpmiddel of overbodig?</title>
                <link rel="canonical" href={route("blogs.twenty-nine")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. Al eerder bespraken we supplementen zoals CLA, pre-workout en omega 3 vetzuren. Vandaag duiken we dieper in op zink om erachter te komen of zink een hulpmiddel is of overbodig. Lees je met ons mee?"
                />
                <meta
                    property="og:description"
                    content="WE ARE Personal Training Uden en Schijndel komt met een nieuwe blog. Al eerder bespraken we supplementen zoals CLA, pre-workout en omega 3 vetzuren. Vandaag duiken we dieper in op zink om erachter te komen of zink een hulpmiddel is of overbodig. Lees je met ons mee?"
                />
                <meta property="og:url" content={route("blogs.twenty-nine")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Zink: hulpmiddel of overbodig? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta property="og:image" content="/assets/blog/" />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/zink.webp"
                                    type="image/webp"
                                    alt="Zink"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/zink.jpg"
                                    type="image/jpeg"
                                    alt="Zink"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/zink.jpg"
                                    alt="Zink"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Zink: hulpmiddel of overbodig?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE Personal Training Uden en Schijndel komt met een
                        nieuwe blog. Al eerder bespraken we supplementen zoals{" "}
                        <a
                            href={route("blogs.twenty-three")}
                            className="text-we-are-yellow"
                        >
                            CLA
                        </a>
                        ,{" "}
                        <a
                            href={route("blogs.twenty-four")}
                            className="text-we-are-yellow"
                        >
                            pre-workout
                        </a>{" "}
                        en{" "}
                        <a
                            href={route("blogs.sixteenth")}
                            className="text-we-are-yellow"
                        >
                            omega 3 vetzuren
                        </a>
                        . Vandaag duiken we dieper in op zink om erachter te
                        komen of zink een hulpmiddel is of overbodig. Lees je
                        met ons mee?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Om te beginnen: wat is zink?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Zink is een spoorelement dat betrokken is bij veel
                        processen in het lichaam. Het is een noodzakelijk
                        spoorelement voor verschillende enzymen. Zonder zink
                        kunnen deze enzymen niet hun werk doen wat maakt dat
                        zink belangrijk is voor je algemene gezondheid. Zink is
                        nodig voor o.a. opbouw van{" "}
                        <a
                            href={route("blogs.third")}
                            className="text-we-are-yellow"
                        >
                            eiwitten
                        </a>{" "}
                        en de ontwikkeling van (spier)weefsel. Daarnaast helpt
                        zink het immuunsysteem te versterken en verhoogt het je
                        testosteron productie.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe krijg je zink binnen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Zink zit o.a. in vlees, kaas, graanproducten, noten en
                        schelpdieren zoals garnalen en mosselen. Belangrijk is
                        om voldoende zink te halen uit je voeding. Mannen hebben
                        ongeveer 20 mg per dag nodig en vrouw 14 mg per dag met
                        uitzondering van de{" "}
                        <a
                            href={route("blogs.fourteenth")}
                            className="text-we-are-yellow"
                        >
                            zwangere vrouwen
                        </a>{" "}
                        . Zij hebben een verhoogd aantal zink nodig van 19 mg
                        per dag (Lukaski, 1995). Producten die veel zink
                        bevatten, per 100 gram zijn o.a. oesters, varkenslever,
                        rundergehakt en walnoten.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Kan je teveel zink binnen krijgen?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is mogelijk om teveel zink binnen te krijgen.
                        Belangrijk is hierop te letten omdat een teveel aan zink
                        ervoor zorgt dat je een koper tekort krijgt wat kan
                        veroorzaken dat je afname van rode bloedcellen ziet.
                        Signalen die wijzen op een koper tekort zijn o.a. snel
                        en veel blauwe blekken krijgen en een slechte groei
                        doormaken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Is het nodig om zink te supplementeren?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je een gevarieerd voedingspatroon hebt waar
                        voldoende{" "}
                        <a
                            href={route("blogs.fourteenth")}
                            className="text-we-are-yellow"
                        >
                            vlees
                        </a>{" "}
                        en vis in terug te zien is betekent dit dat je de
                        aanbevolen hoeveelheid zink binnenkrijgt. Wanneer je
                        vegetariër bent is het nodig om zink te supplementeren
                        omdat deze groep niet voldoende vlees en vis eet.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie: hulpmiddel of overbodig?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Zink is een belangrijk spoorelement en vormt een
                        belangrijk hulpmiddel voor veel processen in je lichaam.
                        Het voldoende binnenkrijgen is dus essentieel voor je
                        algemene gezondheid! Zorg ervoor dat je voldoende zink
                        binnen krijgt zoals de aanbevolen hoeveelheden hierboven
                        omschreven. Dit doe je door voldoende vlees en vis te
                        eten. Mocht je weinig tot geen vlees en vis eten in je
                        voedingspatroon dan is het verstandig om te
                        supplementeren.
                    </p>
                    {/*  */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        Lukaski, H. C. (1995, Juni 5). Opgehaald van Pubmed:{" "}
                        <a
                            href="https://pubmed.ncbi.nlm.nih.gov/7550259/"
                            rel="noopener"
                            className="text-we-are-yellow"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/7550259/{" "}
                        </a>
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
